<template>
    <b-container class="pl-0 pr-0 cat-search">
      <ul class="top-category">
        <li><a v-bind:href="'/blog'" v-bind:class="activeCategory">All Blog</a></li>

        <li v-for="item in blogCategories" 
        :key="item.id" 
         >
            <a v-bind:class="isActive(item.slug)" v-bind:href="'/blog/category/'+item.slug">{{ item.category }}</a>
        </li>
        
        <li v-b-modal.modalBlogSearch>
          <img src="/images/icons/magnifier.svg" />
        </li>
      </ul>
    
    </b-container>
</template>

<script>

import BlogCategoryApi from "~/api/blog_categories.js"

export default {
    data(){
        return {
            blogCategories:[],
            activeCategory:"active", // means all categories,
            limit:3,
        }
    },
    computed:{
        
    },
    methods:{
        isActive(activeCategory) {
            //console.log( activeCategory,"===", this.$route.params.category)
            //return "active"
            if(activeCategory === this.$route.params.category) {
                //console.log(activeCategory,"==>","active")\
                this.activeCategory = ""
                return "active"
            } else {
                //this.activeCategory = ""
                return ""
            }
        },
        fetchBlogCategories(){
            
            let blogCategoryApi = new BlogCategoryApi(this.$axios)

            blogCategoryApi.getAllLimit()
            .then(res => {

                let blogCategories = res.data 

                blogCategories.forEach(item => {
                    //console.log( item )
                    this.blogCategories.push( item )
                })

                // console.log(" data =>", this.blogCategories )

            })
            .catch(err => {

                // console.log( "error => ",err )

            })

        },changeActiveCategory() {
            this.activeCategory = this.$route.params.category
        } 
    },
    beforeMount(){
     
        this.fetchBlogCategories()
        this.changeActiveCategory()
    }
}
</script>

